import React, { Fragment } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Groups from "./components/groups/Groups";
import Layout from "./components/UI/Layout";
import AddProduct from "./pages/AddProduct";
import Categories from "./components/category/Categories";
import CreateCategory from "./pages/CreateCategory";
import Collections from "./components/collection/Collections";
import CreateCollection from "./pages/CreateCollection";
import CreateRole from "./pages/CreateRole";
import CreateUser from "./pages/CreateUser";
import Dashboard from "./pages/Dashboard";
import Graph from "./pages/Graph";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import Products from "./pages/Products";
import Shop from "./pages/Shop";
import Roles from "./pages/Roles";
import Users from "./pages/Users";
import Orders from "./pages/Orders";
import CreateOrder from "./pages/CreateOrder";
import Refunds from "./pages/Refunds";
import Reviews from "./pages/Reviews";
import Addresses from "./pages/Addresses";
import Profile from "./pages/Profile";
import Payments from "./pages/Payments";
import Notifications from "./pages/Notifications";
import AuthContext from "./store/auth-context";
import { SlideImageForm } from "./components/forms/SlideImageForm";
import BulkUpload from "./pages/BulkUpload";
import Settings from "./pages/Settings";
function App() {
  const authCtx = React.useContext(AuthContext);
  const isLoggedIn = authCtx.isLoggedIn;
  return (
    <Routes>
      <Route path="/login">
        <Route
          index
          element={
            <Fragment>
              {isLoggedIn && <Navigate to="/" replace={true} />}
              {!isLoggedIn && <LoginPage />}
            </Fragment>
          }
        />
      </Route>
      <Route
        path="/register"
        element={isLoggedIn ? <Navigate to="/" replace={true} /> : <RegisterPage />}
      />
      <Route
        path="/forgot-password"
        element={isLoggedIn ? <Navigate to="/" replace={true} /> : <ForgotPasswordPage />}
      />
      {isLoggedIn ? (
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="groups" element={<Groups />} />
          <Route path="create-users" element={<CreateUser />} />
          <Route path="create-users/:id" element={<CreateUser />} />
          <Route path="roles" element={<Roles />} />
          <Route path="create-role" element={<CreateRole />} />
          <Route path="shop" element={<Shop />} />
          <Route path="products" element={<Products />} />
          <Route path="bulk-upload" element={<BulkUpload />} />
          <Route path="slide-image" element={<SlideImageForm />} />
          <Route path="categories" element={<Categories />} />
          <Route path="AddCategory/:id" element={<CreateCategory />} />
          <Route path="collections" element={<Collections />} />
          <Route path="AddCollection" element={<CreateCollection />} />
          <Route path="products/add-product/:id" element={<AddProduct />} />
          <Route path="products/add-product" element={<AddProduct />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/create" element={<CreateOrder />} />
          <Route path="refunds" element={<Refunds />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="addresses" element={<Addresses />} />
          <Route path="graphs" element={<Graph />} />
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="payments" element={<Payments />} />
          <Route path="notifications" element={<Notifications />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace={true} />} />
      )}

      <Route path="*" element={<p>not page found</p>} />
    </Routes>
  );
}

export default App;
